var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.flag)?_c('member-top',{attrs:{"userInfo":_vm.userInfo,"statistics":_vm.statistics}}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"w1200 wrap mt20 mb30"},[_c('Menu',{attrs:{"menus":_vm.menus}}),_vm._v(" "),_c('div',{staticClass:"col_2 w920 member_right_con"},[_c('router-view')],1),_vm._v(" "),_c('div',{staticClass:"clear"})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-19b2b2c8","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/page/modules/uc/index.vue
// module id = null
// module chunks = 